// work smarter, not harder.
const _IntentionallyIdenticalTemplatesForAllThemes =
[
	// Form Container wrapper templates
	{
		// NOTE: intentionally empty -- instead we are using FormHeader view injected at #Headlight-View-Header
		HashPostfix: '-Template-Form-Container-Header',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Prefix',
		Template: /*HTML*/`
		<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`,
	},
	{
		HashPostfix: '-Template-Form-Container',
		Template: /*HTML*/`
			<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`,
	},
	{
		// NOTE: intentionally empty -- we don't use these currently, but they are overloaded to reduce template comments in the DOM
		HashPostfix: '-Template-Wrap-Prefix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Wrap-Postfix',
		Template: /*HTML*/``,
	},
	{
		HashPostfix: '-Template-Form-Container-Custom',
		Template: /*HTML*/`
			<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`,
	},
	{
		HashPostfix: '-Template-Form-Container-Wrap-Postfix',
		Template: /*HTML*/`
		</div>`,
	},
	// Form Section, Group, Row templates
	{
		HashPostfix: '-Template-Section-Prefix',
		Template: /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~}" data-i-section-hash="{~D:Record.Hash~}">
			<h2 class="section-header {~ShowSectionTitle:Record~}">{~D:Record.Name~}</h2>`,
	},
	{
		HashPostfix: '-Template-Group-Prefix',
		Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
	},
	{
		HashPostfix: '-Template-Row-Prefix',
		Template: /*HTML*/`
					<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
					<div class="columns {~ColumnsOvercrowded:Record~}">`,
	},
	{
		HashPostfix: '-Template-Row-Postfix',
		Template: /*HTML*/`
					</div>
					<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Group-Postfix',
		Template: /*HTML*/`
				</div>
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
	{
		HashPostfix: '-Template-Section-Postfix',
		Template: /*HTML*/`
		</section>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->`,
	},
];

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: _IntentionallyIdenticalTemplatesForAllThemes,
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: _IntentionallyIdenticalTemplatesForAllThemes,
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [ ..._IntentionallyIdenticalTemplatesForAllThemes,
		// NOTE: optional "HideInPDF" class added for sections
		{
			HashPostfix: '-Template-Section-Prefix',
			Template: /*HTML*/`
			<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<section id="SECTION-{~D:Context[0].formID~}" class="pict-form-section container {~D:Record.CSSClass~} {~HideInPDF:Record~}" data-i-section-hash="{~D:Record.Hash~}">
				<h2 class="section-header {~ShowSectionTitle:Record~}">{~D:Record.Name~}</h2>`,
		},
		// NOTE: optional "HideInPDF" class added for groups
		{
			HashPostfix: '-Template-Group-Prefix',
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="pict-form-group container {~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-content">`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
